// extracted by mini-css-extract-plugin
module.exports = {"sample":"_28KSlkgd1Z","sample-text":"_2E9J2dkK0T"};